import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DetailedActivistProfile from './DetailedActivistProfile';

const ActivistProfile = ({ isPublicView = false }) => {
  const { name } = useParams();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(isPublicView ? '/' : '/activists');
  };

  return (
    <DetailedActivistProfile
      activistName={decodeURIComponent(name)}
      onBack={handleBack}
      isPublicView={isPublicView}
    />
  );
};

export default ActivistProfile;
